import { render, staticRenderFns } from "./Thanksgiving.vue?vue&type=template&id=54a48f2f&scoped=true&"
import script from "./Thanksgiving.vue?vue&type=script&lang=js&"
export * from "./Thanksgiving.vue?vue&type=script&lang=js&"
import style0 from "./Thanksgiving.vue?vue&type=style&index=0&id=54a48f2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a48f2f",
  null
  
)

export default component.exports